angular.module('MW.Framework.SavedSearchService', [
    'MW.Framework.CoreCompanyService',
    'MW.Framework.TagSearchService',
    'Configuration',
    'MW.Framework.NewsService'
])
.factory('SavedSearchService', [
        'NewsService',
        '$q',
        '$http',
        'MASF_SERVICES_URL',
        'MASF_COMPANIES_SERVICES_URL',
        'DASHBOARD_SERVICE_DOMAIN_PUBLIC',
        'translationService',
        'CoreCompanyService',
    function(NewsService, $q, $http, MASF_SERVICES_URL, MASF_COMPANIES_SERVICES_URL, DASHBOARD_SERVICE_DOMAIN_PUBLIC, translationService, CoreCompanyService) {
        'use strict';

        // VARIABLES
        var savedSearchServiceObj = {},
        // member variables
            masfSearchServiceUrl = MASF_SERVICES_URL,
            masfCompaniesServiceUrl = MASF_COMPANIES_SERVICES_URL,
            displayHttpStatusFlashMessage;

        /**
         * Takes in an array and returns a new array of only the unique items from that array
         * @param array - the array you wish to strip duplicate items from
         */
        savedSearchServiceObj.uniqueArrayElementsOnly = function uniqueArrayElementsOnly(array) {
            var uniqueArray = [],
                value,
                i;

            for (i = 0; i < array.length; i = i + 1) {
                value = array[i];
                if (uniqueArray.indexOf(value) === -1) {
                    uniqueArray.push(value);
                }
            }
            return uniqueArray;
        };

        // PROPERTIES
        savedSearchServiceObj.NewsService = NewsService;
        savedSearchServiceObj.duplicate = false;

        // METHODS

        savedSearchServiceObj.getAllSources = function getAllSources(companyId) {

            var defer = $q.defer();

            $http.get(
                DASHBOARD_SERVICE_DOMAIN_PUBLIC + '/dashboard_services/v2/rest/sources/list/' + companyId,
                {cache: false, headers: {}})
                .then(function handleSourcesResponse(response) {
                    defer.resolve(response);
                })
                .catch(function(err) {
                    defer.resolve([]);
                });

            return defer.promise;

        };

        /**
         * Retrieve all search agents for the current user
         *
         * @returns {webdriver.promise.Deferred.promise|*} searches
         */
        savedSearchServiceObj.getAllSavedSearches = function getAllSavedSearches(filter) {

            var defer = $q.defer();

            // We should be caching the list of searches -- GYDA-2058 should do this
            savedSearchServiceObj.NewsService.getCompanySearches(filter).then(function(response) {
                var savedSearches = [];
                if(response && response.data) {

                    // add all searches to our search_service, so they can be accessed from
                    //   any controller within our app
                    angular.forEach(response.data, function(search) {
                        savedSearches.push(search);
                    });
                }

                defer.resolve(savedSearches);
            });

            return defer.promise;
        };

        /**
         * Get a collection of saved searches for a user's company
         * @param savedSearchesArray - the array of saved searches we wish to retrieve
         * @returns {*|Promise|!webdriver.promise.Promise}
         */
        savedSearchServiceObj.getSavedSearches = function getSavedSearches(savedSearchesArray) {
            var savedSearchesIdsArray = [],
                deferred = $q.defer();

            if(savedSearchesArray.length > 0) {
                angular.forEach(savedSearchesArray, function (savedSearch) {
                    savedSearchesIdsArray.push(savedSearch.savedSearchId);
                });

                savedSearchServiceObj.getSavedSearchesByIds(savedSearchesIdsArray)
                    .then(function(searches) {
                        deferred.resolve(searches);
                    })
                    .catch(function(response) {
                        displayHttpStatusFlashMessage(response, false);
                        deferred.resolve([]);
                    });
            } else { // no searches passed in - return nothing
                deferred.resolve([]);
            }

            return deferred.promise;
        };

        /**
         * Get a collection of saved searches for a user's company by id
         * @param searchIds - the array of saved search ids to retrieve search instances for
         * @returns {*|Promise|!webdriver.promise.Promise}
         */
        savedSearchServiceObj.getSavedSearchesByIds = function getSavedSearchesByIds(searchIds) {
            var companyId = CoreCompanyService.getId(),
                url = masfCompaniesServiceUrl + '/' + companyId + '/searches/';

            url = url + searchIds.join(',');
            return $http.get(url)
                .then(function (response) {
                    if (response && response.data) {
                        return response.data;
                    }
                    return [];
                });
        };

        /**
         * Retrieve a saved search by ID
         * First check to see if we have it readily available, if not fetch the
         *   search and return it.
         *
         * @param savedSearchId - ID of the search we want to get
         * @returns {webdriver.promise.Deferred.promise|*} search
         */
        savedSearchServiceObj.getSavedSearchById = function(savedSearchId) {
            var url = masfSearchServiceUrl + '/' + savedSearchId,
                savedSearch = {};

            return $http.get(url).then(function(response) {
                if(response && response.data) {
                    savedSearch = response.data;
                }
                return savedSearch;
            });
        };

        savedSearchServiceObj.currentSearch =  {};

        savedSearchServiceObj.getCurrentSearch = function getCurrentSearch(searchId){
            return savedSearchServiceObj.getSavedSearchById(searchId);
        };

        savedSearchServiceObj.setCurrentSearch = function setCurrentSearch(search){
            savedSearchServiceObj.currentSearch = search;
        };

        return savedSearchServiceObj;
    }]);
